import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getGeofenceData = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/geo-fences/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Geofence data fetch error:", error);
    throw error;
  }
};
const syncGeofence = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/sync_geofences/`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Sync Geofence  error:", error);
    throw error;
  }
};
export { getGeofenceData };
